<template>
  <div class="services-container">
    <h2 class="section-title">My Services</h2>
    
    <div class="services-grid">
      <div class="service-card" v-for="(service, index) in services" :key="index">
        <div class="service-image" :style="{ backgroundImage: `url(${service.image})` }">
          <div class="service-overlay">
            <h3>{{ service.title }}</h3>
            <div class="service-description">
              <p>{{ service.description }}</p>
              <button 
                v-if="service.title === 'Nonprofit Legal Services'"
                class="btn btn-light"
                @click="showLegalServiceModal">
                Learn More
              </button>
              <button 
                v-else
                class="btn btn-light"
                @click="showServiceDetail(service)">
                Learn More
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <ServiceDetailModal
      v-if="selectedService"
      :service="selectedService"
      @close="closeServiceDetail"
    />
    
    <LegalServiceModal
      :show="showLegalModal"
      @close="closeLegalServiceModal"
    />
  </div>
</template>

<script>
import ServiceDetailModal from '@/components/ServiceDetailModal.vue'
import LegalServiceModal from '@/components/LegalServiceModal.vue'

export default {
  name: 'MyServices',
  components: {
    ServiceDetailModal,
    LegalServiceModal
  },
  data() {
    return {
      selectedService: null,
      showLegalModal: false,
      services: [
        {
          title: 'IELTS Test Prep.',
          image: require('../assets/images/ielts-service.jpg'),
          description: 'Start learning new words instantly. Get personalized learning identities that worth you will also learn in and out of the exam and adapt as you grow.',
          detailedDescription: `我们的 IELTS 备考课程为您提供全面的学习体验：

1. 个性化词汇学习系统
   - 智能识别您的词汇水平
   - 根据考试重点定制学习计划
   - 实时调整学习难度和进度

2. 考试技巧培训
   - 听说读写四个模块的专项训练
   - 真题解析和答题策略
   - 时间管理和压力控制技巧

3. 模拟测试系统
   - 完整模拟考试体验
   - 详细的成绩分析报告
   - 针对性的提升建议

4. 一对一辅导服务
   - 专业教师实时指导
   - 个性化学习方案制定
   - 定期进度评估和调整

我们的目标是帮助您不仅通过考试，更要掌握实用的英语技能，为未来的学习和工作打下坚实基础。`
        },
        {
          title: 'Clock-In Learning',
          image: require('../assets/images/clockin-service.png'),
          description: 'Go beyond memorizing. Develop a deeper understanding of how you will learn for knowing the that truly sticks. Boost your real-world English with a new word that learns and grows with you.',
          detailedDescription: `打卡学习系统为您提供科学的语言学习方案：

1. 科学的学习计划
   - 每日学习任务定制
   - 进度追踪和数据分析
   - 灵活的学习时间安排

2. 互动学习体验
   - 多样化的学习活动
   - 实时反馈和纠正
   - 同伴学习和交流机会

3. 奖励机制
   - 连续打卡奖励
   - 学习成就体系
   - 月度学习之星评选

4. 学习效果监测
   - 定期测试评估
   - 学习曲线分析
   - 个性化改进建议

我们的打卡学习系统不仅帮助您建立良好的学习习惯，更能让您在学习过程中获得成就感和持续动力。`
        },
        {
          title: 'Preliminary & Vantage',
          image: require('../assets/images/preliminary-service.jpg'),
          description: 'Master words for life. Gain the confidence to express yourself clearly and more effectively, and write with precision. Step by step, round by round, it has more than you can imagine.',
          detailedDescription: `Preliminary & Vantage 课程系统地提升您的英语水平：

1. 全面的语言技能培养
   - 听说读写全方位提升
   - 地道表达方式训练
   - 实用交际能力培养

2. 阶段性学习目标
   - 清晰的能力等级划分
   - 循序渐进的学习路径
   - 定期的达标测评

3. 实用场景演练
   - 商务英语情境训练
   - 日常生活对话练习
   - 跨文化交际能力培养

4. 个性化学习支持
   - 专业教师指导
   - 学习难点突破
   - 定制化练习材料

通过我们的课程，您将逐步建立起自信和准确的英语表达能力，为未来的学习和工作打开新的机遇。`
        },
        {
          title: 'Nonprofit Legal Services',
          image: require('../assets/images/legal-service.jpg'),
          description: 'To help design your rights free of charge, if you are unable to afford legal help, our office is very prepared to support you. Please connect with us and we will help you as much as we could.'
        }
      ]
    }
  },
  methods: {
    showServiceDetail(service) {
      this.selectedService = {...service}
      document.body.style.overflow = 'hidden'
    },
    closeServiceDetail() {
      this.selectedService = null
      document.body.style.overflow = 'auto'
    },
    showLegalServiceModal() {
      this.showLegalModal = true
      document.body.style.overflow = 'hidden'
    },
    closeLegalServiceModal() {
      this.showLegalModal = false
      document.body.style.overflow = 'auto'
    }
  }
}
</script>

<style scoped>
.services-container {
  padding: 2rem 5%;
  background-color: #ffffff;
  height: 100%;
  overflow-y: auto;  /* 添加这行 */
}

.section-title {
  text-align: center;
  margin-bottom: 3rem;
  font-size: 2.5rem;
  color: #2c3e50;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
}

.service-card {
  height: 400px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.service-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
}

.service-image {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  position: relative;
}

.service-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  text-align: center;
  transition: all 0.3s ease;
}

.service-card:hover .service-overlay {
  background: rgba(52, 152, 219, 0.8);
}

.service-overlay h3 {
  font-size: 1.8rem;
  margin-bottom: 1rem;
  transition: all 0.3s ease;
}

.service-description {
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.3s ease;
}

.service-card:hover .service-description {
  opacity: 1;
  transform: translateY(0);
}

.service-description p {
  margin-bottom: 1.5rem;
}

@media (max-width: 992px) {
  .services-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .services-grid {
    grid-template-columns: 1fr;
  }
}

</style>